import { EmailTemplateKey } from "./email-templates-helper";

export class EmailTemplate {
  emailTemplateId: string;
  code: EmailTemplateKey;
  subjectTemplate: string;
  bodyTemplate: string;
  footerTemplate: string;

  constructor(data: Partial<EmailTemplate> = {}) {
    this.emailTemplateId = data.emailTemplateId ?? '';
    this.code = data.code!;
    this.subjectTemplate = data.subjectTemplate ?? '';
    this.bodyTemplate = data.bodyTemplate ?? '';
    this.footerTemplate = data.footerTemplate ?? '';
  }
}
